import classNames from 'classnames';
import React from 'react';

import './TransactionForm.scss';

type Props = {
    active?: boolean;
    eightCol?: boolean;
    noDateField?: boolean;
    doubleAmountFields?: boolean;
} & React.PropsWithoutRef<JSX.IntrinsicElements['form']>;

const TransactionForm: React.FC<Props> = ({
    active = true,
    eightCol = false,
    className,
    children,
    noDateField = false,
    noValidate = true,
    doubleAmountFields = false,
    ...rest
}) => (
    <form
        className={classNames(
            'transaction-form',
            {
                active,
                'eight-col': eightCol,
                'no-date-field': noDateField,
                'amount-limit-fields': doubleAmountFields,
            },
            className,
        )}
        noValidate={noValidate}
        {...rest}
    >
        {children}
    </form>
);

export default TransactionForm;
